import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  TextField,
  Typography,
  List,
  ListItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  createSegment,
  updateSegment,
  deleteSegment,
} from "../../api/endpoints/enrollmentCrm";

const SegmentsSettingsDialog = ({ open, onClose, segments = [], onSaved, isAdmin = false }) => {
  const [local, setLocal] = useState([]);
  const [newSegment, setNewSegment] = useState({ name: "", description: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLocal([...(segments || [])]);
    setNewSegment({ name: "", description: "" });
    setLoading(false);
  }, [open, segments]);

  const handleAdd = async () => {
    if (!newSegment.name.trim()) return;
    setLoading(true);
    try {
      await createSegment({
        name: newSegment.name.trim(),
        description: newSegment.description?.trim() || null,
      });
      if (onSaved) await onSaved();
      setNewSegment({ name: "", description: "" });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (segment) => {
    setLoading(true);
    try {
      await updateSegment(segment.id, {
        name: segment.name,
        description: segment.description || null,
      });
      if (onSaved) await onSaved();
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (segmentId) => {
    if (!window.confirm("Excluir segmento?")) return;
    setLoading(true);
    try {
      await deleteSegment(segmentId);
      if (onSaved) await onSaved();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>Configurações de Segmentos</DialogTitle>
      <DialogContent dividers>
        {!isAdmin ? (
          <Typography variant="body1" align="center" sx={{ py: 3 }}>
            Somente administradores podem acessar esta funcionalidade.
          </Typography>
        ) : (
          <Box>
            <Paper sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Novo segmento
              </Typography>
              <TextField
                label="Nome"
                fullWidth
                margin="dense"
                value={newSegment.name}
                onChange={(e) => setNewSegment((p) => ({ ...p, name: e.target.value }))}
              />
              <TextField
                label="Descrição"
                fullWidth
                margin="dense"
                value={newSegment.description}
                onChange={(e) => setNewSegment((p) => ({ ...p, description: e.target.value }))}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button variant="contained" onClick={handleAdd} disabled={loading || !newSegment.name.trim()}>
                  Adicionar
                </Button>
              </Box>
            </Paper>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle1" gutterBottom>
              Lista de segmentos
            </Typography>
            <List dense>
              {local.map((seg) => (
                <ListItem key={seg.id} disableGutters sx={{ px: 0, mb: 1 }}>
                  <Paper sx={{ p: 2, width: "100%" }}>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                      <TextField
                        label="Nome"
                        size="small"
                        value={seg.name}
                        onChange={(e) =>
                          setLocal((prev) => prev.map((s) => (s.id === seg.id ? { ...s, name: e.target.value } : s)))
                        }
                        sx={{ flex: 1 }}
                      />
                      <IconButton onClick={() => handleSave(seg)} disabled={loading}>
                        <Typography sx={{ fontWeight: 700, fontSize: 12 }}>Salvar</Typography>
                      </IconButton>
                      <IconButton onClick={() => handleDelete(seg.id)} disabled={loading} color="error">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                    <TextField
                      label="Descrição"
                      size="small"
                      value={seg.description || ""}
                      onChange={(e) =>
                        setLocal((prev) =>
                          prev.map((s) => (s.id === seg.id ? { ...s, description: e.target.value } : s))
                        )
                      }
                      sx={{ mt: 1, width: "100%" }}
                    />
                  </Paper>
                </ListItem>
              ))}
              {local.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                  Nenhum segmento cadastrado.
                </Typography>
              ) : null}
            </List>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={loading}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SegmentsSettingsDialog;

